import { graphql } from "../gql";

export const archiveDirectoryMutationDoc = graphql(`
  mutation archiveDirectory($id: ID!) {
    archiveDirectory(id: $id) {
      ...DirectoryFragment
    }
  }
`);
